<template>
	<b-modal
		:visible="show"
		@hide="() => this.$emit('close')"
		hide-footer
		:title="'Bonus days' | translate"
	>
		<form action="." method="post" class="text-center">
			<fieldset class="form-group">
				<div class="form-check">
					<label class="form-check-label">
						<input
							type="radio"
							class="form-check-input"
							name="optionsRadios"
							v-model="days"
							value="0"
							checked
						/>
						0 {{ 'Days' | translate }}
					</label>
				</div>
				<div class="form-check">
					<label class="form-check-label">
						<input
							type="radio"
							class="form-check-input"
							name="optionsRadios"
							v-model="days"
							value="1"
						/>
						1 {{ 'Week' | translate }}
					</label>
				</div>
				<div class="form-check">
					<label class="form-check-label">
						<input
							type="radio"
							class="form-check-input"
							name="optionsRadios"
							v-model="days"
							value="2"
						/>
						2 {{ 'Weeks' | translate }}
					</label>
				</div>
				<div class="form-check">
					<label class="form-check-label">
						<input
							type="radio"
							class="form-check-input"
							name="optionsRadios"
							v-model="days"
							value="3"
						/>
						3 {{ 'Weeks' | translate }}
					</label>
				</div>
				<div class="form-check">
					<label class="form-check-label">
						<input
							type="radio"
							class="form-check-input"
							name="optionsRadios"
							v-model="days"
							value="days"
						/>
						{{ 'Holiday' | translate }}
					</label>
				</div>

				<div class="form-check" v-if="days === 'days'">
					<label>
						{{ 'The beginning of the holidays' | translate }}
					</label>
					<datepicker v-model="beginning" :format="format"></datepicker>
				</div>
				<div class="form-check" v-if="days === 'days'">
					<label>
						{{ 'Amount of days' | translate }}
					</label>
					<input type="number" class="form-control" v-model="amount" />
				</div>
			</fieldset>
			<button class="btn btn-primary" @click.prevent="sendBonus">
				{{ 'Send' | translate }}
			</button>
		</form>
	</b-modal>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
export default {
	name: 'dashboard-modal-bonus',
	props: ['show'],
	data() {
		return {
			days: '',
			format: 'dd/MM/yyyy',
			beginning: null,
			amount: 1,
		}
	},
	components: {
		Datepicker,
	},
	methods: {
		sendBonus() {
			if (this.days === 'days') {
				let beginning = null
				if (this.beginning !== null) {
					beginning = this.beginning.toISOString().slice(0, 10)
				}
				this.axios({
					method: 'post',
					url: 'users/user/assign_holidays_bonus',
					data: {
						users: this.$store.state.modalId,
						days: this.amount,
						start_date: beginning,
					},
				}).then(response => {
					this.$emit('close')
				})
			} else {
				this.axios({
					method: 'post',
					url: 'users/user/assign_bonus_weeks',
					data: {
						users: this.$store.state.modalId,
						weeks: this.days,
					},
				}).then(response => {
					this.$emit('close')
				})
			}
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button.btn.btn-primary {
	margin: 0;
}
</style>
